/* eslint-disable ember/no-computed-properties-in-native-classes */
import EnrolResult from './enrol-result';
import { alias } from '@ember/object/computed';

export default class LeaverResult extends EnrolResult {
  @alias('leaver')
  response;
}
